import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Translate } from 'react-redux-i18n';
import { Row, Col, Panel, Input } from 'react-bootstrap';

const SalesPerformanceGraph = ({ salesPerformanceData, activeCategoryName, salesPerformanceDateFilterValue, handleChangeSalesPerformanceDateFilter }) => (
  <Panel
    header={<h4><Translate value="sales_cost" />: {activeCategoryName}</h4>}
    className="income-expense-chart"
    style={{ height: 300 }}
  >
    <Row>
      <Col sm={4} smOffset={4}>
        {/* <Field name="SalesPeriod" component={renderRadiosShortPeriod} /> */}
        <Row className="optionStyle">
          <Col sm={6}>
            <p className="radio-inline">
              <Input
                type="radio"
                value="week"
                checked={salesPerformanceDateFilterValue === 'weekly'}
                onClick={() => { handleChangeSalesPerformanceDateFilter('weekly'); }}
              />
              <Translate value="Weekly" />
            </p>
          </Col>
          <Col sm={6}>
            <label className="radio-inline">
              <Input
                type="radio"
                value="month"
                checked={salesPerformanceDateFilterValue === 'monthly'}
                onClick={() => {handleChangeSalesPerformanceDateFilter('monthly')}}
              />
              <Translate value="Monthly" />
            </label>
          </Col>
        </Row>
      </Col>
    </Row>
    <Col>
      <Bar
        data={salesPerformanceData}
        height={200}
        width={300}
        options={{
          maintainAspectRatio: false,
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
              },
            }],
          },
        }}
      />
    </Col>
  </Panel>
);

export default SalesPerformanceGraph;



// WEBPACK FOOTER //
// ./master/jsx/components/General/CategoryAnalysis/components/SalesPerformanceGraph.jsx